import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AnnoncesProvider } from "./context/AnnoncesContext";
import { MessagesProvider } from "./context/MessagesContext";
import { ToastProvider } from "./context/ToastContext";
import { ThemeProvider } from "./context/ThemeContext";
import { CompareProvider } from "./context/CompareContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Accueil from "./pages/Accueil";
import Catalogue from "./pages/Catalogue";
import Connexion from "./pages/Connexion";
import Inscription from "./pages/Inscription";
import MotDePasseOublie from "./pages/MotDePasseOublie";
import DetailAnnonce from "./pages/DetailAnnonce";
import RFQ from "./pages/RFQ";
import MonEspace from "./pages/MonEspace";
import DevenirExposant from "./pages/DevenirExposant";
import AdminDashboard from "./pages/AdminDashboard";
import AjouterAnnonce from "./pages/AjouterAnnonce";
import MesAnnonces from "./pages/MesAnnonces";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import Exposants from "./pages/Exposants";
import ExposantDetail from "./pages/ExposantDetail";
import Messages from "./pages/Messages";
import MesRFQ from "./pages/MesRFQ";
import DemandRFQ from "./pages/DemandRFQ";
import NotFound from "./pages/NotFound";
import Abonnement from "./pages/Abonnement";
import ImportSiteWeb from "./pages/ImportSiteWeb";

// Vider le cache si nouvelle version
const APP_VERSION = "2.1";
if (localStorage.getItem("app_version") !== APP_VERSION) {
  const token = localStorage.getItem("marinadz_token");
  localStorage.clear();
  localStorage.setItem("app_version", APP_VERSION);
  if (token) localStorage.setItem("marinadz_token", token);
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AnnoncesProvider>
            <MessagesProvider>
              <CompareProvider>
                <ToastProvider>
                  <Routes>
                    {/* Public */}
                    <Route path="/" element={<Accueil />} />
                    <Route path="/accueil" element={<Accueil />} />
                    <Route path="/catalogue" element={<Catalogue />} />
                    <Route path="/connexion" element={<Connexion />} />
                    <Route path="/inscription" element={<Inscription />} />
                    <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
                    <Route path="/annonce/:id" element={<DetailAnnonce />} />
                    <Route path="/rfq" element={<RFQ />} />
                    <Route path="/a-propos" element={<APropos />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/exposants" element={<Exposants />} />
                    <Route path="/exposant/:id" element={<ExposantDetail />} />

                    {/* Protected */}
                    <Route path="/mon-espace" element={<ProtectedRoute><MonEspace /></ProtectedRoute>} />
                    <Route path="/devenir-exposant" element={<ProtectedRoute><DevenirExposant /></ProtectedRoute>} />
                    <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                    <Route path="/messages/:convId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                    <Route path="/mes-rfq" element={<ProtectedRoute><MesRFQ /></ProtectedRoute>} />
                    <Route path="/demand-rfq" element={<ProtectedRoute><DemandRFQ /></ProtectedRoute>} />
                    <Route path="/abonnement" element={<ProtectedRoute><Abonnement /></ProtectedRoute>} />

                    {/* Exposant */}
                    <Route path="/ajouter-annonce" element={<ProtectedRoute><AjouterAnnonce /></ProtectedRoute>} />
                    <Route path="/modifier-annonce/:id" element={<ProtectedRoute><AjouterAnnonce editMode={true} /></ProtectedRoute>} />
                    <Route path="/mes-annonces" element={<ProtectedRoute><MesAnnonces /></ProtectedRoute>} />
                    <Route path="/import-site-web" element={<ProtectedRoute><ImportSiteWeb /></ProtectedRoute>} />

                    {/* Admin */}
                    <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />

                    {/* 404 */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </ToastProvider>
              </CompareProvider>
            </MessagesProvider>
          </AnnoncesProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;